<template>
  <v-col cols="12" lg="6" class="mx-auto mt-10 text-center">
    <v-progress-circular
      :width="3"
      color="primary"
      indeterminate
    ></v-progress-circular>
  </v-col>
</template>

<script>
export default {
  name: "Loader",
};
</script>

